import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class UsertokenService {

  constructor() {
    this.loadTokenFromLocalStorage();
  }

  public userTokenKey = "pkvUt";
  private userToken: string | null = null;

  private loadTokenFromLocalStorage() {
    let tokenFromLocalStorage: string | null = null;
    tokenFromLocalStorage = this.tryReadLocalStorageOrWarn();
    if (tokenFromLocalStorage) {
      if (this.isTokenValid(tokenFromLocalStorage)) {
        this.userToken = tokenFromLocalStorage;
      } else {
        localStorage.removeItem(this.userTokenKey);
      }
    }
  }


  public hasValidToken() {
    return this.isTokenValid(this.userToken);
  }

  public isTokenValid(token: string | null) {
    if (token == null) {
      return false;
    }
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp && decodedToken.exp * 1000 > new Date().getTime()) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.warn("found invalid token: ", token);
      return false;
    }
  }

  public logoutUserByUnsetToken() {
    this.userToken = null;
    try {
      localStorage.removeItem(this.userTokenKey);
    } catch (e) {
      // that one does not matter;
    }
  }

  public setUserTokenAfterAuth(token: string) {
    if (!this.isTokenValid(token)) {
      throw new Error("Invalid usertoken provided: " + token);
    }
    this.userToken = token;
    this.tryWriteLocalStorageOrWarn(token);
  }

  public tryWriteLocalStorageOrWarn(token: string) {
    try {
      localStorage.setItem(this.userTokenKey, token);
      console.debug("LocalStorage updated with new token", token);
    } catch (e) {
      console.warn("Could not write Browsers Localstorage, session could expire", e);
    }
  }
  public tryReadLocalStorageOrWarn() {
    try {
      return localStorage.getItem(this.userTokenKey);
    } catch (e) {
      console.warn("Could not read Browsers Localstorage, session could expire", e);
    }
    return null;
  }

  public getUserToken() {
    return this.userToken;
  }

}
